import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { FC, useContext } from "react";
import { Pie } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import AppContext from "../../../../context/app/context";
import { size } from "lodash";

ChartJS.register(ArcElement, Tooltip, Legend);
interface IProps {
  lables?: any[];
  count?: any[];
  colors?: any[];
  label?: string; 
}
const ChartCustom: FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { theme } = useContext(AppContext);

  const data = {
    labels: props?.lables,
    datasets: [
      {
        label: props?.label ?? t("count"),
        data: props?.count,
        backgroundColor: props?.colors ?? [
          "rgba(255, 99, 132, 0.5)",
          "rgba(54, 162, 235, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(75, 192, 192, 0.5)",
          "rgba(153, 102, 255, 0.5)",
          "rgba(255, 159, 64, 0.5)",
        ],

        borderColor: props?.colors ?? [
          "rgba(255, 99, 132, 0.5)",
          "rgba(54, 162, 235, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(75, 192, 192, 0.5)",
          "rgba(153, 102, 255, 0.5)",
          "rgba(255, 159, 64, 0.5)",
        ],
        borderWidth: 1.3,
        rotation: 50,
        hoverOffset: 10,
        hoverBorderWidth: 6,
      },
    ],
  };
  
  type LegendPosition = "top" | "bottom" | "left" | "right";
  const options = {
    plugins: {
      animation: {
        animateRotate: true,
        animateScale: true,
      },
        legend: {
          position: "right" as LegendPosition,
          labels: {
            usePointStyle: true,
            boxWidth: 15,
            padding: 20,
            color: theme === "dark" ? "white" : "black",
            font: {
              size: 14,
            }
          },
        },
    },
  };

  return <Pie data={data} options={options} />;
};

export default ChartCustom;
